import React from 'react';
import { InvestorFormData } from '@/utils/formValidation/investorForm';
import { DatePicker } from '../ui/DatePicker';
import { PhoneNumberField } from '../ui/PhoneNumberField';
import { TextField } from '../ui/TextField';

type CompanyRepresentativeSectionProps = {
  formData: InvestorFormData;
  onFieldChange: (field: keyof InvestorFormData, value: string | boolean) => void;
  getFieldError: (field: keyof InvestorFormData) => string | undefined;
};

export const CompanyRepresentativeSection: React.FC<CompanyRepresentativeSectionProps> = ({
  formData,
  onFieldChange,
  getFieldError,
}) => {
  return (
    <div className="flex flex-col gap-4">
      <h3 className="text-base font-semibold text-gray-900 font-avenir">Company Representative</h3>
      <div className="flex flex-col sm:flex-row w-full items-start justify-between gap-4 sm:gap-2">
        {/* Left Column */}
        <div className="flex h-full w-full sm:w-1/2 flex-col items-center justify-start gap-2 py-2">
          <div className="flex w-full flex-col items-start justify-start gap-2">
            {/* First Name */}
            <TextField
              value={formData.firstName}
              onChange={(value) => onFieldChange('firstName', value)}
              placeholder="First Name"
              error={!!getFieldError('firstName')}
            />
            {/* Middle Name */}
            <TextField
              value={formData.middleName}
              onChange={(value) => onFieldChange('middleName', value)}
              placeholder="Middle Name"
              error={!!getFieldError('middleName')}
            />
            {/* Last Name */}
            <TextField
              value={formData.lastname}
              onChange={(value) => onFieldChange('lastname', value)}
              placeholder="Last Name"
              error={!!getFieldError('lastname')}
            />
          </div>
        </div>

        {/* Right Column */}
        <div className="flex h-full w-full sm:w-1/2 flex-col items-center justify-start gap-2 py-2">
          <div className="flex w-full flex-col items-start justify-start gap-2">
            {/* Date of Birth */}
            <DatePicker
              value={formData.dateOfBirth}
              onChange={(date) => onFieldChange('dateOfBirth', date)}
              placeholder="Date of Birth"
              label="Date of Birth"
              error={!!getFieldError('dateOfBirth')}
            />

            {/* Email */}
            <TextField
              value={formData.email}
              onChange={(value) => onFieldChange('email', value)}
              placeholder="Email"
              type="email"
              error={!!getFieldError('email')}
            />

            {/* Phone Number */}
            <PhoneNumberField
              value={formData.phone}
              onChange={(value) => onFieldChange('phone', value)}
              placeholder="Phone Number"
              error={!!getFieldError('phone')}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
